import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {provideRouter, withHashLocation} from '@angular/router'
import routes from './app-routes'
import {environment} from '../environments/environment'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {ENVIRONMENT, HOME_PATH} from './0-application/constants'

import {registerLocaleData} from '@angular/common'
import localeSv from '@angular/common/locales/sv'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'

registerLocaleData(localeSv)

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: ['public']
}

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'Välkommen till Sparbanken Syds tjänst för att signera dokument.' +
          ' För att komma vidare måste du identifiera dig med BankID',
        buttonText: 'Identifiera med BankID',
        route: ['/', HOME_PATH]
      }
    },
    {provide: ENVIRONMENT, useValue: environment},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        appearance: 'outline',
        floatLabel: 'always'
      }
    },
    provideRouter(routes, withHashLocation()),

    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),

    provideAppInitializer(() =>
      inject(ConfigService).bootstrap())
  ]
}